import { useCallback, useEffect, useState } from 'react'

import { getProductionAssignmentScopes } from '@/api/studio-production'

export function useAssignmentScopes(productionId: string, isOwner: boolean) {
  const [loading, setLoading] = useState(!isOwner)
  const [editableKeys, setEditableKeys] = useState<Set<string>>(new Set())

  useEffect(() => {
    if (!productionId) return
    if (isOwner) {
      setEditableKeys(new Set())
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    void getProductionAssignmentScopes(productionId)
      .then((res) => {
        if (cancelled) return
        const next = new Set<string>()
        for (const item of res.items) {
          if (item.editable) {
            next.add(`${item.item_type}:${item.item_public_id}`)
          }
        }
        setEditableKeys(next)
      })
      .catch(() => {
        if (!cancelled) setEditableKeys(new Set())
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [productionId, isOwner])

  const canEdit = useCallback(
    (itemType: string, itemPublicId: string) => {
      if (isOwner) return true
      return editableKeys.has(`${itemType}:${itemPublicId}`)
    },
    [isOwner, editableKeys],
  )

  return { loading, canEdit, isOwner }
}
